import { ForecastService } from "../services/forecastService";

(module => {
    "use strict";

    module.component('summaryForecast', {
        template: require('./summaryForecastComponent.html'),
        bindings: {
            parameters: '<',
            market: "<",
            brands: "=",
            forecastId: '<',
            isEditable: '<'
        },
        controller: ['$scope', ForecastService.componentName, '$stateParams', function(
            this: $TSFixMe,
            $scope: $TSFixMe,
            forecastService: ForecastService,
            $stateParams: ng.ui.IStateParamsService
        ) {
            const $ctrl = this;
            $ctrl.showYears = true;
            $ctrl.showDataYears = true;
            $ctrl.showDefenceSummary = false;

            $ctrl.isCollapsed = {};

            $ctrl.$onInit = () => {
                recalculateShowCorrectionAfterDefence();
                $ctrl.hasCorrectionAfterDefence = getHasCorrectionAfterDefence();
                if ($ctrl.hasCorrectionAfterDefence) {
                    forecastService.getCorrectionAfterDefenceForecastVaues($stateParams.id).then((correctedForecast: $TSFixMe) => $ctrl.correctedForecast = correctedForecast);
                }

                $scope.$watch('$ctrl.parameters.forecastType.typeId', function (typeId: $TSFixMe) {
                    if (typeId)
                        $ctrl.MktshVal = $ctrl.ppgVal = $ctrl.absoluteVal = $ctrl.pmForecastAndExfacoryVal = $ctrl.parameters.forecastType.typeId == 'value';
                });

                $scope.$watch('$ctrl.selectedBrand', function () {
                    recalculateShowCorrectionAfterDefence();
                });
            }

            function recalculateShowCorrectionAfterDefence() {
                $ctrl.showDefenceSummary = $ctrl.selectedBrand && $ctrl.selectedBrand.customData && $ctrl.selectedBrand.customData.values.customValues &&
                    
                    _.some($ctrl.selectedBrand.customData.values.customValues, (value: $TSFixMe) => !angular.isUndefinedOrNull(value));
                if ($ctrl.selectedBrand && $ctrl.hasCorrectionAfterDefence && $ctrl.correctedForecast) {
                    
                    $ctrl.brandAfterCorrection = _.find($ctrl.correctedForecast.market.brands, (b: $TSFixMe) => b.name == $ctrl.selectedBrand.name);
                } else {
                    $ctrl.brandAfterCorrection = null;
                }
            }

            function getHasCorrectionAfterDefence() {
                
                return _.some($ctrl.brands, (b: $TSFixMe) => b.customData && b.customData.values.customValues && _.some(b.customData.values.customValues, (value: $TSFixMe) => !angular.isUndefinedOrNull(value)));
            }
        }]
    });


})(angular.module('topline.modules'));